module.exports = __webpack_public_path__ + "img/LogoOff.1faea317.png";